export default {
  'beitragen.survivalinternational.de': 'de',
  'hazte-socio-dona.survival.es': 'es',
  'donate.survivalinternational.org': 'us',
  'donner.survivalinternational.fr': 'fr',
  'dona.survival.it': 'it',
  'doar.survivalbrasil.org': 'br'
}
